/*
 * .nomcaché — Judge.me review-body translation fallback.
 * Draft-theme only: map an API review ID to Judge.me's rendered review UUID.
 */
(function () {
  'use strict';

  if (window.__nomcacheJudgeMeReviewFallback) return;

  var REVIEWS = [
    {
      reviewId: '1315622210',
      domReviewUuid: '6030785c-bb12-4b62-ae30-3d63eb905356',
      original: 'Test czy dziala',
      translations: {
        en: 'Test if it works',
        nl: 'Test of het werkt',
        fr: 'Test pour voir si ça marche'
      }
    }
  ];

  var WIDGET_ID = 'judgeme_product_reviews';
  var WIDGET_CLASS = 'jdgm-review-widget';
  var REVIEW_SELECTOR = '.jm-review-item[review-uuid]';
  var BODY_SELECTOR =
    '.jm-review-content__body .jdgm-review-content__body-content > p';
  var MAX_WIDGET_LOOKUPS = 120;
  var observer;
  var widget;
  var scheduled = false;
  var lookups = 0;

  function currentLocale() {
    var language = document.documentElement.getAttribute('lang');
    return language ? language.toLowerCase().split('-')[0] : '';
  }

  function reviewForUuid(uuid) {
    for (var index = 0; index < REVIEWS.length; index += 1) {
      if (REVIEWS[index].domReviewUuid === uuid) return REVIEWS[index];
    }
    return null;
  }

  function desiredBody(review) {
    var language = currentLocale();
    if (language === 'pl') return review.original;
    return review.translations[language] || null;
  }

  function translateKnownReviews() {
    if (!widget || !widget.isConnected) return;

    var items = widget.querySelectorAll(REVIEW_SELECTOR);
    for (var index = 0; index < items.length; index += 1) {
      var item = items[index];
      var review = reviewForUuid(item.getAttribute('review-uuid'));
      var text = review && desiredBody(review);
      var body = item.querySelector(BODY_SELECTOR);

      if (text && body && body.textContent !== text) body.textContent = text;
    }
  }

  function scheduleTranslation() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      translateKnownReviews();
    });
  }

  function attachToWidget(candidate) {
    if (observer) observer.disconnect();
    widget = candidate;
    observer = new MutationObserver(scheduleTranslation);
    observer.observe(widget, { childList: true, subtree: true });
    translateKnownReviews();
  }

  function findWidget() {
    var candidate = document.getElementById(WIDGET_ID);
    if (candidate && candidate.classList.contains(WIDGET_CLASS)) {
      lookups = 0;
      if (candidate !== widget) attachToWidget(candidate);
      else translateKnownReviews();
      return;
    }

    if (lookups < MAX_WIDGET_LOOKUPS) {
      lookups += 1;
      requestAnimationFrame(findWidget);
    }
  }

  window.__nomcacheJudgeMeReviewFallback = Object.freeze({ refresh: findWidget });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', findWidget, { once: true });
  } else {
    findWidget();
  }
}());

